var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { ManufacturersClient, ModelsClient, CompaniesClient, GetManufacturerListPaginatedQuery, GetModelListPaginatedQuery, PaginatedEnumerableOfManufacturerModel, PaginatedEnumerableOfModel, SortDescription, SortDirection, ManufacturerTypeEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { CacheHelper } from "@/app/utils/cache-helper";
import Sorter from "@/common/utils/sorter";
import RouteNames from "@/app/router/routes";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
const companyClient = new CompaniesClient(window.apiUrl);
const manufacturersClient = new ManufacturersClient(window.apiUrl);
const modelsClient = new ModelsClient(window.apiUrl);
let ManufacturersVue = class ManufacturersVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.viewMode = 'battery';
        this.companies = [];
        // Manufacturers
        this.sorter = new Sorter(new SortDescription({
            fieldName: "ManufacturerName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetManufacturerListPaginatedQuery({
            companyId: 0,
            keywords: "",
            pageNo: 1,
            pageSize: 100,
            sort: this.sorter.currentSort,
        });
        this.manufacturersData = new PaginatedEnumerableOfManufacturerModel();
        this.manufacturerColumns = [
            { visible: true, fieldName: "manufacturerName", title: "Name" },
        ];
        // Controller Models
        this.modelsSorter = new Sorter(new SortDescription({
            fieldName: "ModelName",
            direction: SortDirection.Ascending
        }));
        this.modelsQuery = new GetModelListPaginatedQuery({
            companyId: 0,
            manufacturerId: 0,
            keywords: "",
            pageNo: 1,
            pageSize: 100,
            sort: this.modelsSorter.currentSort,
        });
        this.modelsData = new PaginatedEnumerableOfModel();
        this.modelColumns = [
            { visible: true, fieldName: "modelName", title: "Name" }
        ];
    }
    created() {
        this.loadDataGridState();
        this.getCompanies();
    }
    ;
    getCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            this.working = true;
            return yield companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = companies;
                if (!companies.length)
                    return;
                this.working = false;
                this.restoreCachedFilters();
                if (!this.query.companyId)
                    this.company = companies[0];
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    onViewModeChanged() {
        this.searchAttempted = false;
        this.search();
    }
    onCompanyChanged() {
        if (this.viewMode === 'batteryMonitor') {
            this.query.companyId = this.modelsQuery.companyId;
        }
        else {
            this.modelsQuery.companyId = this.query.companyId;
        }
    }
    searchManufacturers() {
        if (this.viewMode === 'batteryMonitor')
            return;
        if (this.working)
            return;
        if (!this.query)
            return;
        // Set manufacturer type based on current tab
        if (this.viewMode === 'battery') {
            this.query.manufacturerTypeId = ManufacturerTypeEnum.Battery;
        }
        else if (this.viewMode === 'upsCharger') {
            this.query.manufacturerTypeId = ManufacturerTypeEnum.ChargerUPS;
        }
        this.working = true;
        manufacturersClient
            .search(this.query)
            .then((response) => {
            this.manufacturersData = new PaginatedEnumerableOfManufacturerModel();
            if (!response)
                return;
            this.manufacturersData = response;
            this.query.pageNo = this.manufacturersData.displayedPage;
            this.query.pageSize = this.manufacturersData.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    searchControllerModels() {
        if (this.viewMode !== 'batteryMonitor')
            return;
        if (this.working)
            return;
        if (!this.modelsQuery)
            return;
        this.working = true;
        modelsClient
            .search(this.modelsQuery)
            .then((response) => {
            this.modelsData = new PaginatedEnumerableOfModel();
            if (!response)
                return;
            this.modelsData = response;
            this.modelsQuery.pageNo = this.modelsData.displayedPage;
            this.modelsQuery.pageSize = this.modelsData.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    search() {
        if (this.viewMode === 'batteryMonitor') {
            this.searchControllerModels();
        }
        else {
            this.searchManufacturers();
        }
    }
    onDataGridStateChanged() {
        if (this.viewMode === 'batteryMonitor') {
            DataGridStateHelper.storeDataGridState("controller-models-grid", this.modelColumns, this.modelsSorter, false);
        }
        else {
            DataGridStateHelper.storeDataGridState("manufacturers-grid", this.manufacturerColumns, this.sorter, false);
        }
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            this.onDataGridStateChanged();
            this.search();
        }
    }
    ;
    onModelsSortChanged() {
        this.modelsQuery.sort = this.modelsSorter.currentSort;
        if (!this.working) {
            this.onDataGridStateChanged();
            this.search();
        }
    }
    ;
    edit(manufacturer) {
        var _a;
        this.$router.push({ name: RouteNames.Manufacturer, params: { companyId: this.query.companyId, id: manufacturer.manufacturerId.toString() }, query: { manufacturerTypeId: (_a = manufacturer.manufacturerTypeId) === null || _a === void 0 ? void 0 : _a.toString() } });
    }
    ;
    editModel(model) {
        this.$router.push({ name: RouteNames.Model, params: { companyId: this.query.companyId, manufacturerId: 0, id: model.modelId.toString() } });
    }
    ;
    deleteManufacturer(manufacturer) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to delete this manufacturer?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            manufacturersClient
                .delete(manufacturer.manufacturerId, false)
                .then(() => {
                var _a;
                this.manufacturersData.records = (_a = this.manufacturersData.records) === null || _a === void 0 ? void 0 : _a.filter(m => m.manufacturerId !== manufacturer.manufacturerId);
                this.manufacturersData.recordCount = (this.manufacturersData.recordCount || 1) - 1;
                Notifier.onOk(`Manufacturer ${manufacturer.manufacturerName} has been successfully deleted.`);
                this.working = false;
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    let errorMessage = "";
                    try {
                        const errorObj = typeof ex.response === 'string' ? JSON.parse(ex.response) : ex.response;
                        errorMessage = (errorObj === null || errorObj === void 0 ? void 0 : errorObj.title) || (errorObj === null || errorObj === void 0 ? void 0 : errorObj.message) || ex.message || "";
                    }
                    catch (_a) {
                        errorMessage = ex.message || "";
                    }
                    if (errorMessage.includes("model(s) associated")) {
                        this.$confirmModal.show(`${errorMessage}\n\nDo you want to delete the manufacturer and all associated models?`, { title: "Confirm Deletion" }).then((confirmForce) => {
                            if (!confirmForce) {
                                this.working = false;
                                return;
                            }
                            manufacturersClient
                                .delete(manufacturer.manufacturerId, true)
                                .then(() => {
                                var _a;
                                this.manufacturersData.records = (_a = this.manufacturersData.records) === null || _a === void 0 ? void 0 : _a.filter(m => m.manufacturerId !== manufacturer.manufacturerId);
                                this.manufacturersData.recordCount = (this.manufacturersData.recordCount || 1) - 1;
                                Notifier.onOk(`Manufacturer ${manufacturer.manufacturerName} and associated models have been successfully deleted.`);
                            })
                                .catch((ex2) => {
                                HttpHelper.handleResponse(ex2, () => {
                                    Notifier.onServerError(ex2);
                                });
                            })
                                .finally(() => {
                                this.working = false;
                            });
                        }).catch(() => {
                            this.working = false;
                        });
                    }
                    else {
                        Notifier.onServerError(ex);
                        this.working = false;
                    }
                });
            });
        });
    }
    ;
    deleteModel(model) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to delete this controller model?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            modelsClient
                .delete(model.modelId)
                .then(() => {
                var _a;
                this.modelsData.records = (_a = this.modelsData.records) === null || _a === void 0 ? void 0 : _a.filter(m => m.modelId !== model.modelId);
                this.modelsData.recordCount = (this.modelsData.recordCount || 1) - 1;
                Notifier.onOk(`Controller model ${model.modelName} has been successfully deleted.`);
                this.working = false;
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
                this.working = false;
            });
        });
    }
    ;
    cacheFilters() {
        CacheHelper.storeItem(RouteNames.Manufacturers, "CompanyId", String(this.query.companyId));
    }
    restoreCachedFilters() {
        var companyId = CacheHelper.getItem(RouteNames.Manufacturers, "CompanyId");
        if (companyId) {
            this.query.companyId = companyId;
            this.modelsQuery.companyId = companyId;
        }
    }
    get pageTitle() {
        return 'Manufacturers';
    }
    ;
    get currentQuery() {
        return this.viewMode === 'batteryMonitor' ? this.modelsQuery : this.query;
    }
    get currentData() {
        return this.viewMode === 'batteryMonitor' ? this.modelsData : this.manufacturersData;
    }
    get currentColumns() {
        return this.viewMode === 'batteryMonitor' ? this.modelColumns : this.manufacturerColumns;
    }
    get noData() {
        return this.searchAttempted && (!this.currentData || !this.currentData.records || !this.currentData.records.length);
    }
    ;
    get noModelsData() {
        return this.searchAttempted && (!this.modelsData || !this.modelsData.records || !this.modelsData.records.length);
    }
    ;
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    ;
    get numberOfVisibleColumns() {
        return this.currentColumns.filter(column => column.visible).length;
    }
    ;
    isVisible(name) {
        let column = this.manufacturerColumns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    isVisibleModel(name) {
        let column = this.modelColumns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    loadDataGridState() {
        this.working = true;
        try {
            var state = DataGridStateHelper.loadDataGridState("manufacturers-grid", this.manufacturerColumns, this.sorter);
            var modelState = DataGridStateHelper.loadDataGridState("controller-models-grid", this.modelColumns, this.modelsSorter);
        }
        finally {
            this.working = false;
        }
    }
    getCompanyName(companyId) {
        if (!companyId)
            return "";
        const company = this.companies.find(c => c.value === companyId);
        return (company === null || company === void 0 ? void 0 : company.text) || "";
    }
    get currentManufacturerTypeId() {
        if (this.viewMode === 'battery') {
            return ManufacturerTypeEnum.Battery;
        }
        else if (this.viewMode === 'upsCharger') {
            return ManufacturerTypeEnum.ChargerUPS;
        }
        return undefined;
    }
    get company() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set company(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
        this.modelsQuery.companyId = item.value;
        this.cacheFilters();
    }
    ;
};
__decorate([
    Watch("viewMode"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManufacturersVue.prototype, "onViewModeChanged", null);
__decorate([
    Watch("query.companyId"),
    Watch("modelsQuery.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManufacturersVue.prototype, "onCompanyChanged", null);
__decorate([
    Watch("query.companyId"),
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManufacturersVue.prototype, "searchManufacturers", null);
__decorate([
    Watch("modelsQuery.companyId"),
    Watch("modelsQuery.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManufacturersVue.prototype, "searchControllerModels", null);
__decorate([
    Watch("numberOfVisibleColumns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManufacturersVue.prototype, "onDataGridStateChanged", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManufacturersVue.prototype, "onSortChanged", null);
__decorate([
    Watch("modelsSorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ManufacturersVue.prototype, "onModelsSortChanged", null);
ManufacturersVue = __decorate([
    Component({
        name: "ManufacturersVue"
    })
], ManufacturersVue);
export default ManufacturersVue;
